import { render, staticRenderFns } from "./AddDeliveryInfo.vue?vue&type=template&id=986ca138&"
import script from "./AddDeliveryInfo.vue?vue&type=script&lang=ts&"
export * from "./AddDeliveryInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AddDeliveryInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports